import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbarContext } from "../../utils/snackbar/SnackbarContext";
import { appConstants } from "../../utils/appConstants";
import { useDropzone } from 'react-dropzone';
import { useParams } from "react-router-dom";


const InfoEdit = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [link, setLink] = useState("");
  const [status, setStatus] = useState<number>(1);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const { showSnackbar } = useSnackbarContext();


  // URLからIdパラメータを取得
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    (async () => {
      try {
        const { idToken } = (await fetchAuthSession()).tokens ?? {};
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/info/${id}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            }
          }
        );
        // console.log('Response:', response.data);
        const info = response.data;
        setTitle(info.title);
        setBody(info.body);
        setLink(info.link);
        setStatus(info.status);

        const imageFileName = `info-1-1-${id}`;
        // ユニークなタイムスタンプを付与してキャッシュ対策 
        const timestamp = new Date().getTime();
        const imageRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/image/${imageFileName}?t=${timestamp}`,
          {
            headers: {
              'Content-Type': 'application/json'
            },
            responseType: 'blob',
          }
        );
        const imageUrl = URL.createObjectURL(imageRes.data);
        setPreview(imageUrl);
      } catch (error) {
        console.error('Error fetching info:', error);
      }
    })();
  }, []);

  const onDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const info = {
      title,
      body,
      link,
      status
    };

    try {
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/info/${id}`,
        info,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        }
      );
      console.log('Response:', response.data);

      if (response.data) {
        if (selectedFile) {
          // IDを元に画像名を生成してアップロード
          const id = response.data.id;
          const fileName = `info-1-1-${id}`;
          const extension = selectedFile.name.substring(selectedFile.name.lastIndexOf('.') + 1);
          const formData = new FormData();
          formData.append('image', selectedFile, fileName + '.' + extension);
        
          try {
              const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/upload-image`, formData);
              console.log('ファイルのアップロードが完了しました', response.data);
          } catch (error) {
            console.error('ファイルのアップロードに失敗しました', error, idToken);
          }
        }
        showSnackbar("success", appConstants.SUCCESS_UPDATE);
      }
    } catch (error) {
      console.error('Error posting info:', error);
    }
  }


  return (
    <>
      <h2>1. 基本情報</h2>
      <form onSubmit={handleSubmit}>
        <div className="tableEdit">
          <div
            {...getRootProps()}
            style={{
              border: '2px dashed #cccccc',
              padding: '20px',
              textAlign: 'center',
              cursor: 'pointer',
            }}
          >
            <input {...getInputProps()} />
            {preview ? (
              <img src={preview} alt="Preview" style={{ maxWidth: '300px'}} />
            ) : (
              <p>ここをクリックするか画像をドラッグしてください</p>
            )}
          </div>
          <table>
            <tbody>
              <tr>
                <th>タイトル</th>
                <td>
                  <input type="text" name="name" value={title} onChange={(e) => setTitle(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>本文</th>
                <td>
                  <textarea
                    name="body" 
                    value={body} 
                    onChange={(e) => setBody(e.target.value)} 
                    required
                    rows={5} cols={30}
                    style={{ resize: 'none'}}
                  />
                </td>
              </tr>
              <tr>
                <th>リンク先</th>
                <td>
                  <input type="text" name="link" value={link} onChange={(e) => setLink(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>ステータス</th>
                <td>
                  <input type="radio" name="status" value={0} id="status0" checked={status === 0} onChange={(e) => setStatus(Number(e.target.value))}/> 
                  <label htmlFor="status0" style={{ marginRight: '10px' }}>非公開</label>
                  <input type="radio" name="status" value={1} id="status1" checked={status === 1} onChange={(e) => setStatus(Number(e.target.value))}/>
                  <label htmlFor="status1">公開</label>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div className="submit">
                    <input type="submit" value="更新" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </>
  );
}
export default InfoEdit;